"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createPresenceComponentVariant: function() {
        return createPresenceComponentVariant;
    },
    overridePresenceMotion: function() {
        return overridePresenceMotion;
    }
});
const _createPresenceComponent = require("./createPresenceComponent");
function overridePresenceMotion(presenceMotion, override) {
    return (...args)=>{
        const { enter, exit } = presenceMotion(...args);
        return {
            enter: {
                ...enter,
                ...override.all,
                ...override.enter
            },
            exit: {
                ...exit,
                ...override.all,
                ...override.exit
            }
        };
    };
}
function createPresenceComponentVariant(component, override) {
    return (0, _createPresenceComponent.createPresenceComponent)(overridePresenceMotion(component[_createPresenceComponent.MOTION_DEFINITION], override));
}
